import { gql } from "@apollo/client";

export const FETCH_CHAT = gql`
    query getChat($id: ID!) {
        chat(id: $id) {
            id
            createdAt
            updatedAt
            creatorId
            creatorName
            isPrivate
            name
            generatedSummary
            sizeInTokens
            sizeInPages
            totalTokensSpent
            totalPagesSpent
            graphEnabled
            companyContextEnabled
            gptOnlyEnabled
            isFavorite
            isGenerating
        }
    }
`;
